module.exports = __webpack_public_path__ + "static/media/kitchen.364abc21.mp3";